import authAxios from 'src/modules/shared/axios/authAxios';

export default class MeditationService {
  static async update(id, data) {
    const body = {
      id,
      data,
    };

    const response = await authAxios.put(`/meditation/${id}`, body);

    return response.data;
  }

  static async destroyAll(ids) {
    const params = { ids };

    const response = await authAxios.delete(`/meditation`, { params });

    return response.data;
  }

  static async create(data) {
    const body = {data};    

    const response = await authAxios.post(`/meditation`, body);

    return response.data;
  }

  static async find(id) {
    const response = await authAxios.get(`/meditation/${id}`);    
    
    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const response = await authAxios.get(`/meditation`, { params });
    
    return response.data;
  }

  static async unarchiveAll(ids) {
    const body = {
      ids,
    };

    const response = await authAxios.put(`/meditation/unarchive`, body);

    return response.data;
  }

  static async listAutocomplete(query, limit) {
    const params = {
      query,
      limit,
    };

    const response = await authAxios.get(
      `/meditation/autocomplete`,
      {
        params,
      },
    );

    return response.data;
  }
}
